export default function RichSnippets({ data }) {
  return (
    <head>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
    </head>
  );
}
